import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";

import ReportList from "components/viewerLists/reportList/ReportList";
import ApplicationState from "store/ApplicationState";

import ErrorPane from "../ErrorPane";
import Layout from "../Layout";

const ViewerDocumentsPage = (_props: any) => {
  const { user = undefined } = useSelector(
    ({ auth }: ApplicationState) => auth
  );

  const features = useSelector(({ sys }: ApplicationState) => sys.features);

  const { error = undefined } = useSelector(
    ({ documentsList }: ApplicationState) => documentsList
  );

  return (
    <Layout
      requisitionsNav={
        user?.has_access_to_report_list && features?.clinicRequisitionsList
      }
      reportsNav={
        user?.has_access_to_report_list && features?.clinicReportsList
      }
    >
      <Helmet>
        <title>
          Case{" "}
          {_props.reportType === "report" ? "Reports" : "Requisition Forms"} -
          PathologyWatch
        </title>
      </Helmet>
      {error ? (
        <ErrorPane error={error} />
      ) : (
        <ReportList reportType={_props.reportType} />
      )}
    </Layout>
  );
};

export default ViewerDocumentsPage;
